module.exports = __webpack_public_path__ + "img/bottomlogo.21beb8e7.png";